import { Button } from "@/components/ui/button";
import { LoginFormCard } from "@/features/auth/components/login-form-card";
import { SignupFormCard } from "@/features/auth/components/signup-form-card";
import * as m from "@/libs/i18n/messages";
import { Link, LogInIcon, UserRoundCheckIcon } from "lucide-react";
import { usePlainModal } from "../ui/modal";

export function AuthActions() {
  const loginModal = usePlainModal(LoginFormCard);
  const signupModal = usePlainModal(SignupFormCard);

  return (
    <div className="space-x-6">
      <Button intent="soft" flavor="gray" className="sr-only" asChild>
        <Link to="/auth/login">
          <LogInIcon />
          {m.bland_small_dragonfly_peek()}
        </Link>
      </Button>
      <Button intent="soft" flavor="gray" onClick={() => loginModal.show()}>
        <LogInIcon />
        {m.bland_small_dragonfly_peek()}
      </Button>

      <Button intent="solid" className="sr-only" asChild>
        <Link to="/auth/signup">
          <UserRoundCheckIcon />
          {m.gaudy_bold_hare_read()}
        </Link>
      </Button>
      <Button intent="solid" onClick={() => signupModal.show()}>
        <UserRoundCheckIcon />
        {m.gaudy_bold_hare_read()}
      </Button>
    </div>
  );
}
